import { jsx as _jsx } from "react/jsx-runtime";
import { getMessage } from '@@client/lib/messages';
export default function FormFieldErrors(_ref) {
  var errors = _ref.errors,
      id = _ref.id;
  var haveErrors = errors && errors.length;
  if (!haveErrors) return '';
  return /*#__PURE__*/_jsx("ul", {
    id: id,
    "aria-live": "polite",
    className: "errors",
    children: errors.map(function (x, i) {
      return /*#__PURE__*/_jsx("li", {
        children: getMessage(x)
      }, i);
    })
  });
}